import { CommanderFormProps, UseDialogFormControlsParams, useHandledDialogFormControls } from '../../dialogForm';
import { TabProps } from '../types';

export type UseTabbedDialogFormControlsParams<
    TabValues extends string,
    InputValues extends object,
    OutputValues extends object = InputValues,
> = Omit<UseDialogFormControlsParams<InputValues, OutputValues>, 'mode'> &
    CommanderFormProps &
    Pick<TabProps<TabValues>, 'currentTab'>;

export const useTabbedDialogFormControls = <T extends string, I extends object, O extends object = I>({
    currentTab,
    ...other
}: UseTabbedDialogFormControlsParams<T, I, O>) => {
    const { renderFormContent, ...formControls } = useHandledDialogFormControls<I, O>({
        ...other,
        mode: 'onChange',
    });

    type FormContent = ReturnType<typeof renderFormContent>;
    type TabMatcher = (matchingMap: Record<T, () => FormContent>) => FormContent;

    return {
        ...formControls,
        renderFormContent: (render: (props: { matchTabs: TabMatcher }) => FormContent) =>
            render({ matchTabs: (matchingMap) => renderFormContent(matchingMap[currentTab]()) }),
    };
};
